<template>
    <InputText
        :field="{
            display: '',
            width: 100,
            type: 'number',
            handle: 'quantity',
            default: '1',
            validate: [],
        }"
        class="product-select quantity-input !my-0 !w-[90px] border bg-transparent"
    />
</template>

<style scoped>
    :deep(label) {
        gap: 0;
    }

    :deep(input) {
        background-color: transparent;
        @apply text-2xl lg:text-3xl;
    }
</style>
